import { EditorState, convertToRaw } from 'draft-js';

// Clés de verrou des variables référencées par le contenu d'une box, quelle
// que soit sa forme : EditorState vivant (texte/titre), raw DraftJS stringifié
// (cellules de tableau, contenus imbriqués), structures mixtes. Pour une
// variable texte custom, la clé d'entité ('custom.<id>') est exactement la
// valeur de boxVariableSelectedId — donc la clé claim/release — quand un user
// l'édite au formulaire. Les clés API ne sont jamais verrouillées : les
// retourner est inoffensif.
const RAW_VARIABLE_NEEDLE = '"type":"VARIABLE"';

const collectFromEntityMap = (entityMap, keys) => {
  Object.values(entityMap ?? {}).forEach((entity) => {
    if (entity.type === 'VARIABLE' && typeof entity.data?.key === 'string') {
      keys.add(entity.data.key);
    }
  });
};

const walk = (value, keys) => {
  if (!value) return;
  if (typeof value === 'string') {
    if (!value.includes(RAW_VARIABLE_NEEDLE)) return;
    try {
      collectFromEntityMap(JSON.parse(value).entityMap, keys);
    } catch (e) {
      // pas un raw DraftJS valide : ignoré
    }
    return;
  }
  if (value instanceof EditorState) {
    collectFromEntityMap(convertToRaw(value.getCurrentContent()).entityMap, keys);
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((item) => walk(item, keys));
    return;
  }
  if (typeof value === 'object') {
    Object.values(value).forEach((item) => walk(item, keys));
  }
};

export const variableLockKeysInBox = (box) => {
  const keys = new Set();
  walk(box?.content, keys);
  return [...keys];
};
